import { Dropdown } from "react-bootstrap";
import TableDropdownMenu from "./TableDropdownMenu";

interface Props {
  record: Record<string, string>;
  selected: string;
  onSelect: (str: string | null) => void;
  isDisabled?: boolean;
}

export default function RecordDropdown({
  record,
  selected,
  onSelect,
  isDisabled = false,
}: Readonly<Props>) {
  const entries = Object.entries(record);
  return (
    <Dropdown onSelect={onSelect}>
      <Dropdown.Toggle
        id="dropdown-basic"
        className="d-flex align-items-center justify-content-between"
        style={{ width: "200px" }}
        variant="light"
        disabled={isDisabled}
      >
        {record[selected]}
      </Dropdown.Toggle>
      <TableDropdownMenu>
        {entries.map(([key, value], idx) => (
          <div key={key}>
            <Dropdown.Item eventKey={key}>{value}</Dropdown.Item>
            {idx !== entries.length - 1 && <Dropdown.Divider />}
          </div>
        ))}
      </TableDropdownMenu>
    </Dropdown>
  );
}
